<template>
  <div
    v-bind:class="{
      'widget-wrapper': true,
      'widget-wrapper-with-margins': !isPresentation,
    }"
  >
    <div class="widget-target" ref="frameNode"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import qs from "query-string";
import pickBy from "../helpers/pickBy";
import {
  BASENAME,
  BT_PATH,
  HANDLE_PAGE_CHANGE,
  LOCAL_DEV_THEME,
} from "../store/modules/app";
import { layouts } from "../getRandomLayout";
import {
  betaPromoImagesUrl,
  devPromoImagesUrl,
  prodPromoImagesUrl,
} from "../store/envs";

const isHandlePageChange = (routing) => routing === HANDLE_PAGE_CHANGE;
const isBtPath = (routing) => routing === BT_PATH;
const isBasename = (routing) => routing === BASENAME;

const getThemesBaseUrl = (branch) =>
  branch === LOCAL_DEV_THEME
    ? "http://localhost:8081/"
    : `https://bt-app-static-themes.sptpub.com/${branch}/`;

export default {
  name: "Widget",
  data() {
    return {
      isMobile: null,
      betsTotal: 0,
    };
  },
  props: {
    config: Object,
  },
  computed: {
    ...mapState("app", [
      "activeBrand",
      "activeEnv",
      "selectedThemesBranch",
      "showDemoPopup",
      "isPresentation",
      "showBottomPanel",
      "builderVisible",
      "editorVisible",
      "routing",
    ]),
    ...mapState("auth", ["lang", "theme", "token", "isLoggedIn"]),
  },
  methods: {
    getTop() {
      const DEMO_POPUP_HEIGHT = 48;
      const MOBILE_DEMO_POPUP_HEIGHT = 112;
      const OPERATOR_HEADER = 64;
      const MOBILE_OPERATOR_HEADER = 56;

      return this.showDemoPopup
        ? this.isMobile
          ? MOBILE_DEMO_POPUP_HEIGHT + MOBILE_OPERATOR_HEADER
          : DEMO_POPUP_HEIGHT + OPERATOR_HEADER
        : this.isMobile
        ? MOBILE_OPERATOR_HEADER
        : OPERATOR_HEADER;
    },
    getSportsbookRoute() {
      return (
        (window.location.pathname + window.location.search).replace(
          this.getRoutePath(),
          ""
        ) || "/"
      );
    },
    getUrl() {
      return isHandlePageChange(this.routing) && this.getSportsbookRoute();
    },
    getRoutePath() {
      return (
        "/sportsbook" +
        (this.$route.params.layout ? `/${this.$route.params.layout}` : "")
      );
    },
    getBasename() {
      return isBasename(this.routing) ? this.getRoutePath() : null;
    },
    onPopState() {
      if (this.frame) {
        this.frame.updateOptions({ url: this.getSportsbookRoute() });
      }
    },
    convertUrl() {
      if (this.$router.currentRoute.fullPath.startsWith("/sportsbook")) {
        const parsedQuery = qs.parse(window.location.search);
        const sportsbookPath =
          parsedQuery["bt-path"] ||
          layouts.reduce((res, layout) => {
            // replace tile, sidebar, classic but not table-tennis
            const regExp = new RegExp("/" + layout + "([^-]|$)");
            return res.replace(regExp, "/");
          }, window.location.pathname.replace("/sportsbook", "")) ||
          "/";
        console.log("sportsbookPath", sportsbookPath);
        const newParsedQuery = isBtPath(this.routing)
          ? { ...parsedQuery, "bt-path": sportsbookPath }
          : pickBy(parsedQuery, (_, k) => k !== "bt-path");
        const queryString = qs.stringify(newParsedQuery);

        window.history.replaceState(
          "",
          "",
          this.getRoutePath() +
            (!isBtPath(this.routing) ? sportsbookPath : "") +
            (queryString ? `?${queryString}` : "")
        );
      }
    },
    getPromoImagesUrl() {
      if (this.activeEnv.name) {
        if (this.activeEnv.name.includes("dyn-")) {
          return devPromoImagesUrl;
        }
        if (this.activeEnv.name.includes("beta")) {
          return betaPromoImagesUrl;
        }
      }

      return prodPromoImagesUrl;
    },
    getHandlePageChange() {
      return (
        isHandlePageChange(this.routing) &&
        ((url, action) => {
          this.$router[action === "REPLACE" ? "replace" : "push"](
            `${this.getRoutePath()}${url}`
          );
        })
      );
    },
    updateUrlOptions() {
      if (this.frame) {
        this.frame.updateOptions({
          url: this.getUrl(),
          handlePageChange: this.getHandlePageChange(),
          basename: this.getBasename(),
        });
      }
    },
    changeOffset() {
      if (this.frame) {
        this.frame.updateOptions({
          stickyTop: this.getTop(),
          betSlipOffsetTop: this.getTop(),
        });
      }
    },
    isMobileListener(e) {
      this.isMobile = !!e.matches;
    },
    init() {
      const mql = window.matchMedia("(max-width: 600px)");
      this.isMobile = !!mql.matches;

      mql.addListener(this.isMobileListener);

      if (this.frame) {
        mql.removeListener(this.isMobileListener);
        this.frame.kill();
      }

      // kill all instances before for correct instances counter, than initialize
      setTimeout(() => {
        this.frame = new BTRenderer().initialize({
          token: this.token,
          onTokenExpired: () => {
            return new Promise((resolve) => {
              const newToken = prompt("Please enter new token");
              resolve(newToken);
            });
          },
          onShareBetClick: ({ url }) => {
            console.log("received url to share", url);

            return {
              url,
              text: "Share text from the callback!",
            };
          },
          promoImagesUrl: this.getPromoImagesUrl(),
          brand_id: this.activeBrand,
          lang: this.lang,
          themeName: process.env.PRESENTATION
            ? `${this.theme}-${this.$route.params.layout}`
            : this.theme,
          themesBaseUrl: getThemesBaseUrl(this.selectedThemesBranch),
          apiUrl: this.activeEnv.apiUrl,
          target: this.$refs.frameNode,
          stickyTop: this.getTop(),
          betSlipOffsetTop: this.getTop(),
          betSlipOffsetBottom: this.showBottomPanel ? 64 : 0,
          onMatchTrackerReady: (node) => {
            const styles = document.createElement("style");
            styles.innerHTML =
              ".container { background: red; width: 300px; height: 200px; }";
            const div = document.createElement("div");
            div.appendChild(styles);
            const container = document.createElement("div");
            container.classList.add("container");
            container.innerHTML = "<div>hello</div>";
            div.appendChild(container);
            node.innerHTML = "";
            node.appendChild(div);
          },
          basename: this.getBasename(),
          url: this.getUrl(),
          handlePageChange: this.getHandlePageChange(),
          onBannerClick: (args) => {
            console.log(
              `custom action onBannerClick is called with argumants:`,
              args
            );

            const isAbsoluteUrl = /^[a-z][a-z0-9+.-]*:/.test(args.url);

            if (isAbsoluteUrl) {
              window.location.href = args.url;
            } else {
              this.frame.updateOptions({ url: args.url });
            }
          },
          ...this.config,
        });
      }, 0);
    },
    updateTheme(themeName) {
      this.frame.updateOptions({ themeName });
    },
  },
  mounted() {
    this.init();

    if (isHandlePageChange(this.routing)) {
      window.addEventListener("popstate", this.onPopState);
    }

    this.convertUrl();
  },
  watch: {
    routing() {
      if (isHandlePageChange(this.routing)) {
        window.addEventListener("popstate", this.onPopState);
      } else {
        window.removeEventListener("popstate", this.onPopState);
      }
      this.convertUrl();
      this.updateUrlOptions();
    },
    isMobile() {
      this.changeOffset();
    },
    builderVisible(builderVisible) {
      this.frame.updateOptions({ builderVisible });
    },
    editorVisible(editorVisible) {
      this.frame.updateOptions({ editorVisible });
    },
    showDemoPopup() {
      this.changeOffset();
    },
    frame() {
      this.changeOffset();
    },
    theme() {
      this.frame.updateOptions({
        themeName: process.env.PRESENTATION
          ? `${this.theme}-${this.$route.params.layout}`
          : this.theme,
        basename: this.getBasename(),
      });
    },
    selectedThemesBranch() {
      this.frame.updateOptions({
        themesBaseUrl: getThemesBaseUrl(this.selectedThemesBranch),
      });
    },
    $route(to) {
      this.frame.updateOptions({
        themeName: process.env.PRESENTATION
          ? `${this.theme}-${to.params.layout}`
          : this.theme,
        basename: this.getBasename(),
      });
    },
    currency() {
      if (!this.isLoggedIn) {
        this.init();
      }
    },
    lang() {
      if (!this.isLoggedIn) {
        this.init();
      }
    },
    token() {
      this.init();
    },
  },
  destroyed() {
    if (this.frame) {
      this.frame.kill();
    }
    window.removeEventListener("popstate", this.onPopState);
  },
};
</script>

<style>
@media (min-width: 600px) {
  .widget-wrapper-with-margins {
    width: 100%;
    margin: 0 auto;
  }
}
.widget-wrapper,
.widget-target {
  height: 100%;
}
</style>
